import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './FandOFut.css';
import { useNavigate } from "react-router-dom";

function FandOFut(props) {
    const [optionType, setOptionType] = useState('');
    const [optionFuture, setOptionFuture] = useState('');
    const [optionOpt, setOptionOpt] = useState('');
    let getOptionValue = props.optionValue;
    let navigate = useNavigate();

    useEffect(() => {
         if (optionFuture === "Most Active Contracts") {
            navigate("/Futures-And-Options/Most-Active-Contracts");
        }
        if (optionFuture === "Overview") {
            navigate("/market/futures-and-options");
        }
        if (optionFuture === "All Index Future") {
            navigate("/Futures-And-Options/All-Index-Future");
        }
        if (optionFuture === "Top Gainers (Futures)") {
            navigate("/Futures-And-Options/Top-Gainers-Futures");
        }
        if (optionFuture === "Top Losers (Futures)") {
            navigate("/Futures-And-Options/Top-Losers-Futures");
        }
        if (optionFuture === "Highest in OI (Futures)") {
            navigate("/Futures-And-Options/Highest-in-OI-Futures");
        }
        if (optionFuture === "Lowest in OI (Futures)") {
            navigate("/Futures-And-Options/Lowest-in-OI-Futures");
        }
        if (optionFuture === "Increase in OI in % (Futures)") {
            navigate("/Futures-And-Options/Increase-in-OI-Futures");
        }
        if (optionFuture === "Decrease in OI in % (Futures)") {
            navigate("/Futures-And-Options/Decrease-in-OI-Futures");
        }
    }, [optionFuture]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-selectFut'>
                                        
                                        {/* aria-label="Select Overview Option" */}
                                        <select aria-label="Select Overview Option" value={getOptionValue} onChange={(event) => { setOptionFuture(event.target.value) }}>
                                            <option value="Overview">Overview</option>
                                            <option value="Most Active Contracts">Most Active Contracts</option>
                                            <option value="All Index Future">All Index Future</option>
                                            <option value="Top Gainers (Futures)">Top Gainers (Futures)</option>
                                            <option value="Top Losers (Futures)">Top Losers (Futures)</option>
                                            <option value="Highest in OI (Futures)">Highest in OI (Futures)</option>
                                            <option value="Lowest in OI (Futures)">Lowest in OI (Futures)</option>
                                            <option value="Increase in OI in % (Futures)">Increase in OI in % (Futures)</option>
                                            <option value="Decrease in OI in % (Futures)">Decrease in OI in % (Futures)</option>
                                        </select>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default FandOFut;